export default {
  '测试记录列表':'测试记录列表',
  '日期':'日期',
  '请输入名称/发布人模糊搜索':'请输入名称/发布人模糊搜索',
  '视频不存在':'视频不存在',
  '运动时长':'运动时长',
  '锻炼时间':'锻炼时间',
  '测试记录':'测试记录',
  '姓名、学籍号模糊搜索':'姓名、学籍号模糊搜索',
  '用户列表':'用户列表',
  '未开始':'未开始',
  '进行中':'进行中',
  '已结束':'已结束',
  '关键字':'关键字',
  '请输入名称关键字':'请输入名称关键字',
  '秒':'秒',

  //4.17
  '时间':'时间',
  '组别':'组别',
  '第':'第',
  '组':'组',
  '请输入组名ID成员模糊搜索':'请输入组名/ID/成员模糊搜索',
  '随堂赛记录':'随堂赛记录',
  '组名':'组名',
  '组ID':'组ID',
  '成员':'成员',
  '总成绩':'总成绩',
  '平均成绩':'平均成绩',
  '小时':'小时',
  '分':'分',
  '完成时间':'完成时间',
}